import { AppState } from '../../../store/store';
import { Dispatch } from 'react';
import { AnyAction } from 'redux';
import { ThunkResult } from './ThunkResult';
import { toast } from '@luminara/ui-components';

export const showSuccessNotificationAction = (description = 'Done', durationInMs = 5000): ThunkResult<void> => {
  return async (dispatch: Dispatch<AnyAction>, getState: () => AppState) => {
    toast({
      description: <>{description} ✨</>,
      variant: 'default',
      duration: durationInMs,
    });
  };
};
